(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  const cache = new Map();
  const queue = [];
  let active = 0;
  const pump = () => {
    while (active < 4 && queue.length) {
      const job = queue.shift();
      active += 1;
      job().finally(() => { active -= 1; pump(); });
    }
  };
  const readBadge = (href) => {
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin || !/\/products\/[^/]+$/.test(url.pathname)) return Promise.resolve(null);
    const key = url.pathname;
    if (!cache.has(key)) {
      cache.set(key, new Promise((resolve) => {
        queue.push(async () => {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 8000);
          try {
            url.search = '?view=ariat-toe-badge';
            const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
            if (!response.ok) throw new Error('Badge unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const badge = doc.querySelector('.ariat-toe-badge');
            resolve(badge ? { label: badge.textContent.trim(), soft: badge.classList.contains('ariat-toe-badge--soft') } : null);
          } catch (_) { resolve(null); }
          finally { clearTimeout(timeout); }
        });
        pump();
      }));
    }
    return cache.get(key);
  };
  const labelCard = (card) => {
    if (card.dataset.ariatToeChecked) return;
    const vendor = card.querySelector('.spf-product-card__vendor');
    const image = card.querySelector('.spf-product-card__image-wrapper');
    if (!vendor || vendor.textContent.trim().toLowerCase() !== 'ariat' || !image) return;
    card.dataset.ariatToeChecked = 'true';
    readBadge(image.getAttribute('href')).then((value) => {
      if (!value || !card.isConnected || card.querySelector('.ariat-toe-badge')) return;
      const badge = document.createElement('span');
      badge.className = 'f-badge ariat-toe-badge ariat-toe-badge--' + (value.soft ? 'soft' : 'safety');
      badge.textContent = value.label;
      image.appendChild(badge);
    });
  };
  let scheduled = false;
  const scan = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      main.querySelectorAll('.spf-product-card').forEach(labelCard);
    });
  };
  new MutationObserver(scan).observe(main, { childList: true, subtree: true });
  scan();
})();
